export default "__VITE_ASSET__15b5278a__"